import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import Config from './Config.js';

export default class Travail extends Config{

	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, data) {
		super(currentEnv, roomName, roomConfig, whereToAddObjects, data);

		if (data) {
			this.data = {entrePole: parseFloat(data.ep), praticable: (data.p == "true"), isEcranMural: (data.em == "true")};
		}
		else {
			this.data = {entrePole: 2.5, praticable: false, isEcranMural: false};
		}

		this.praticableObject = this.currentEnv.getObjectByName("Praticable_" + this.roomName);
		this.plafonnierObject = this.currentEnv.getObjectByName("Plafonnier_" + this.roomName);
		this.sortieSecoursObject = this.currentEnv.getObjectByName("SortieSecours_" + this.roomName);

		this.roomWithDifferentPlacement = ["8", "9", "10", "11"];
	}

	Show() {
		if (!this.refPole) {
			this.CreateTable();
		}
		else if (!this.refPraticable) {
			this.CreatePraticable();
		}
		else if(!this.refPlafonnier) {
			this.CreatePlafonnier();
		}
		else if(!this.refSortieSecours) {
			this.CreateSortieSecours();
		}
		else {
			var currentPole = [];
			var currentPraticables = [];
			var currentPlafonnier = [];
			var currentSortieSecours = [];

			for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
				if (this.whereToAddObjects.children[i].name == "Pole") {
					currentPole.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = true;
					this.whereToAddObjects.children[i].simsData.id = currentPole.length;
				}

				if (this.whereToAddObjects.children[i].name == "Praticable") {
					currentPraticables.push(this.whereToAddObjects.children[i]);
					if (this.data.praticable) {
						this.whereToAddObjects.children[i].visible = true;
					}
					else {
						this.whereToAddObjects.children[i].visible = false;
					}
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentPraticables.length;
				}

				if (this.whereToAddObjects.children[i].name == "Ecran_Plafonnier") {
					currentPlafonnier.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
				}

				if (this.whereToAddObjects.children[i].name == "Sortie_Secours") {
					currentSortieSecours.push(this.whereToAddObjects.children[i]);
					this.whereToAddObjects.children[i].visible = false;
					this.whereToAddObjects.children[i].simsData = structuredClone(this.simsData);
					this.whereToAddObjects.children[i].simsData.id = currentSortieSecours.length;
				}
			}

			var plafonnierPos = this.plafonnierObject.getObjectByName("Plafonnier_" + this.roomConfig);
			if (plafonnierPos) {
				if (currentPlafonnier.length >= 1) {
					this.objectGenerator.ApplyTransform(currentPlafonnier[0], {refObject: plafonnierPos});
					if (this.data.isEcranMural) {
						currentPlafonnier[0].visible = true;
					}
				}
				else {
					this.objectGenerator.CloneElement(this.refPlafonnier, this.whereToAddObjects, {refObject: plafonnierPos});
				}
			}

			var distancePos = this.distanceObject.getObjectByName("Distance_" + this.roomConfig);
			if (distancePos) {
				this.CreateDistances(distancePos);
			}

			var delim = this.delimZones.getObjectByName("DRoom_" + this.roomConfig);
			var zoneDelimData = this.SetupDelimData(delim);

			if (zoneDelimData.length) {
				zoneDelimData = zoneDelimData[0];
			}

			zoneDelimData.minZ += 2;
			zoneDelimData.maxZ -= 2;
			zoneDelimData.minX += 2;
			zoneDelimData.maxX -= 2;

			switch(this.roomConfig) {
				case "1_2":
					zoneDelimData.minX += 0.5;
					break;
				case "1_2_3":
					zoneDelimData.minX += 0.5;
					break;
				case "8":
				case "9":
				case "10":
				case "11":
					zoneDelimData.minX += 0.5;
					zoneDelimData.maxX -= 0.5;
					break;
			}

			var sortieSecoursPos = this.sortieSecoursObject.getObjectByName("SortieSecours_" + this.roomConfig);
			if (sortieSecoursPos) {
				if (sortieSecoursPos.children.length) {
					for (var i = 0; i < sortieSecoursPos.children.length; i++) {
						if (i < currentSortieSecours.length) {
							this.objectGenerator.ApplyTransform(currentSortieSecours[i], {refObject: sortieSecoursPos.children[i]});
							currentSortieSecours[i].visible = true;
						}
						else {
							currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos.children[i]}));
							currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
						}
					}
				}
				else {
					if (currentSortieSecours.length >= 1) {
						this.objectGenerator.ApplyTransform(currentSortieSecours[0], {refObject: sortieSecoursPos});
						currentSortieSecours[0].visible = true;
					}
					else {
						currentSortieSecours.push(this.objectGenerator.CloneElement(this.refSortieSecours, this.whereToAddObjects, {refObject: sortieSecoursPos}));
						currentSortieSecours[currentSortieSecours.length - 1].simsData.id = currentSortieSecours.length;
					}
				}
			}

			if (this.data.praticable) {
				switch(this.roomConfig) {
					case "1":
					case "2":
					case "3":
						zoneDelimData.minZ += 1;
						break;
					case "1_2":
					case "1_2_3":
						zoneDelimData.maxX -= 2.5;
						break;
					case "2_3":
						zoneDelimData.minX += 2.5;
						break;
				}

				var praticablePos = this.praticableObject.getObjectByName(this.roomConfig);
				if (praticablePos) {
					for (var i = 0; i < praticablePos.children.length; i++) {
						if (i < currentPraticables.length)
							this.objectGenerator.ApplyTransform(currentPraticables[i], {refObject: praticablePos.children[i]});
						else {
							currentPraticables.push(this.objectGenerator.CloneElement(this.refPraticable, this.whereToAddObjects, {refObject: praticablePos.children[i]}));
							currentPraticables[currentPraticables.length - 1].simsData.id = currentPraticables.length;
						}
					}
				}
				else {
					for (var i = 0; i < this.whereToAddObjects.children.length; i++) {
						if (this.whereToAddObjects.children[i].name == "Praticable") {
							this.whereToAddObjects.children[i].visible = false;
						}
					}
				}
			}

			var realDistance = {};
			var newPos = {};
			realDistance.x = Math.floor((zoneDelimData.maxX - zoneDelimData.minX) / (Math.floor((zoneDelimData.maxX - zoneDelimData.minX) / this.data.entrePole)) * 10) / 10;
			realDistance.z = Math.floor((zoneDelimData.maxZ - zoneDelimData.minZ) / (Math.floor((zoneDelimData.maxZ - zoneDelimData.minZ) / this.data.entrePole)) * 10) / 10;

			var newPole;
			var poleCount = 0;
			var nbRange = 0;
			var ratioSup;

			if (this.roomWithDifferentPlacement.includes(this.roomConfig)) {
				ratioSup = realDistance.x / 2;
			}
			else {
				ratioSup = realDistance.z / 2;
			}

			if (this.roomWithDifferentPlacement.includes(this.roomConfig)) {
				for (var i = zoneDelimData.minZ; i < zoneDelimData.maxZ; i += realDistance.z) {
					for (var j = (nbRange%2 == 0)?zoneDelimData.minX:zoneDelimData.minX + ratioSup; j < zoneDelimData.maxX; j += realDistance.x) {
						newPos.posX = j;
						newPos.posZ = i;

						if (poleCount < currentPole.length) {
							this.objectGenerator.ApplyTransform(currentPole[poleCount], newPos);
						}
						else {
							currentPole.push(this.objectGenerator.CloneElement(this.refPole, this.whereToAddObjects, {posX: newPos.posX, posZ: newPos.posZ, rotY: 0}));
							currentPole[currentPole.length - 1].simsData.id = currentPole.length;
							/*newPole = this.refPole.clone();
							this.whereToAddObjects.add(newPole);
							newPole.rotation.set(0, 0, 0);
							this.objectGenerator.ApplyTransform(newPole, newPos);*/
						}

						poleCount++;
					}
					nbRange++;
				}
			}
			else {
				for (var i = zoneDelimData.minX; i < zoneDelimData.maxX; i += realDistance.x) {
					for (var j = (nbRange%2 == 0)?zoneDelimData.minZ:zoneDelimData.minZ + ratioSup; j < zoneDelimData.maxZ; j += realDistance.z) {
						newPos.posX = i;
						newPos.posZ = j;

						if (poleCount < currentPole.length) {
							this.objectGenerator.ApplyTransform(currentPole[poleCount], newPos);
						}
						else {
							currentPole.push(this.objectGenerator.CloneElement(this.refPole, this.whereToAddObjects, {posX: newPos.posX, posZ: newPos.posZ, rotY: 0}));
							currentPole[currentPole.length - 1].simsData.id = currentPole.length;
							/*newPole = this.refPole.clone();
							this.whereToAddObjects.add(newPole);
							newPole.rotation.set(0, 0, 0);
							this.objectGenerator.ApplyTransform(newPole, newPos);*/
						}

						poleCount++;
					}
					nbRange++;
				}
			}

			if (this.simsDataFunction) {
				this.simsDataFunction();
			}
			if (currentPole.length > poleCount) {
				this.HideObjectAdded(currentPole, poleCount);
			}
			this.data.type = "Travail";
			this.data.poleCount = poleCount;
		}
	}

	Modify(value) {
		if (value.type == "entrePole") {
			this.data.entrePole = parseFloat(value.value);
		}
		else if (value.type == "isEcranMural") {
			this.data.isEcranMural = value.value;
		}
		else if (value.type == "praticable") {
			this.data.praticable = value.value;
		}
		this.Show();
	}

	ChangeRoomConfig(roomName, roomConfig) {
		this.roomConfig = roomConfig;
		this.roomName = roomName;
	}

	CreatePraticable() {
		this.refPraticable = this.whereToAddObjects.getObjectByName("Praticable");
		if (this.refPraticable) {
			this.refPraticable.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePraticable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Praticable", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreateTable() {
		this.refPole = this.whereToAddObjects.getObjectByName("Pole");
		if (this.refPole) {
			this.refPole.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateTable();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Pole", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	CreatePlafonnier() {
		this.refPlafonnier = this.whereToAddObjects.getObjectByName("Ecran_Plafonnier");
		if (this.refPlafonnier) {
			this.refPlafonnier.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreatePlafonnier();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("Ecran_Plafonnier", this.whereToAddObjects, newPos);
		}
	}

	CreateSortieSecours() {
		this.refSortieSecours = this.whereToAddObjects.getObjectByName("Sortie_Secours");
		if (this.refSortieSecours){
			this.refSortieSecours.visible = false;
			this.Show();
		}
		else {
			var functionToSend = function(e){
				this.CreateSortieSecours();
			}.bind(this);
			var newPos = {functionToAdd: functionToSend};

			this.objectGenerator.AddElement("bibliotheque/Sortie_Secours", this.whereToAddObjects, newPos, undefined , this.simsData);
		}
	}

	ResetBaseConfig() {
		this.data = {entrePole: 2.5, praticable: false};
	}
}